'use client'

import Link from 'next/link'
import { CatIcon, DogIcon, HamsterIcon, ArrowRightIcon } from './icons'

const CATEGORIES = [
  {
    icon: CatIcon,
    label: 'Cat',
    handle: 'cat',
    description: 'Food, litter, furniture & more',
    gradient: 'from-teal-50 to-emerald-50',
    accent: 'text-teal-700',
    border: 'border-teal-100 hover:border-teal-300',
    iconBg: 'bg-teal-100',
  },
  {
    icon: DogIcon,
    label: 'Dog',
    handle: 'dog',
    description: 'Food, treats, toys & accessories',
    gradient: 'from-orange-50 to-amber-50',
    accent: 'text-orange-700',
    border: 'border-orange-100 hover:border-orange-300',
    iconBg: 'bg-orange-100',
  },
  {
    icon: HamsterIcon,
    label: 'Small Animals',
    handle: 'small-animals',
    description: 'Food, bedding & housing',
    gradient: 'from-violet-50 to-purple-50',
    accent: 'text-violet-700',
    border: 'border-violet-100 hover:border-violet-300',
    iconBg: 'bg-violet-100',
  },
]

export function PetSelectCategories() {
  return (
    <section className="py-14 md:py-18 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-[#0B7A75] text-xs font-semibold tracking-widest uppercase mb-2">Categories</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            Shop by Pet
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {CATEGORIES.map((cat) => {
            const Icon = cat.icon
            return (
              <Link
                key={cat.handle}
                href={`/categories/${cat.handle}`}
                className={`group relative rounded-2xl border ${cat.border} bg-gradient-to-br ${cat.gradient} p-6 md:p-8 transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5`}
              >
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${cat.iconBg} mb-4`}>
                  <Icon className={`w-6 h-6 ${cat.accent}`} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{cat.label}</h3>
                <p className="text-gray-500 text-sm mb-4">{cat.description}</p>
                <span className={`inline-flex items-center gap-1.5 ${cat.accent} font-semibold text-sm group-hover:gap-2.5 transition-all`}>
                  Shop {cat.label}
                  <ArrowRightIcon className="w-3.5 h-3.5" />
                </span>
              </Link>
            )
          })}
        </div>
      </div>
    </section>
  )
}
